import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Button } from 'src/shared/components/ui/buttons/button'
import { useWindowSize } from 'src/shared/hooks/use-window-size'
import { cn } from 'src/shared/utils/cn'

interface DownloadAppButtonProps {
  theme?: 'light' | 'dark'
}

export default function DownloadAppButton({ theme = 'dark' }: DownloadAppButtonProps) {
  const navigate = useNavigate()
  const { width } = useWindowSize()

  const downloadAppOnClick = () => {
    navigate(paths.downloadApp.getHref())
  }

  return (
    <Button
      variant="default"
      onClick={downloadAppOnClick}
      className={cn(
        'h-[30px] min-h-0 rounded-full bg-primary px-3 text-[12px] font-medium text-white xs:h-[35px] xs:px-[15px] xs:text-[14px]',
        theme === 'light' && 'bg-white text-primary',
      )}
    >
      {width < 500 ? 'Download' : 'Download App'}
    </Button>
  )
}
